document.addEventListener("DOMContentLoaded", async () => {
  const button = document.querySelector(".brand-follow-button[data-brand]");
  if (!button) return;
  const brand = button.dataset.brand;
  const email = button.dataset.customerEmail;
  if (!brand || !email) return;

  // Check follow status on page load
  try {
    const statusRes = await fetch(
      `/apps/brand-follow?type=brand-follow&email=${encodeURIComponent(email)}&brand=${encodeURIComponent(brand)}`
    );
    if (statusRes.ok) {
      const statusData = await statusRes.json();
      const following = Array.isArray(statusData.followed_brands) && statusData.followed_brands.includes(brand);
      if (following) {
        setFollowing(button, true);
      }
    }
  } catch (error) {
    console.error("Could not load follow status", error);
  }

  // Handle button click
  button.addEventListener("click", async () => {
    const isFollowing = button.classList.contains("is-following");
    const action = isFollowing ? "unfollow" : "follow";
    button.disabled = true;
    try {
      const response = await fetch("/apps/brand-follow?type=brand-follow", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, brand, action }),
      });
      if (!response.ok) {
        throw new Error("Brand follow request failed");
      }
      const data = await response.json();
      setFollowing(button, data.following);
    } catch (error) {
      console.error(error);
      alert("Sorry, we couldn't update your preference. Please try again.");
    } finally {
      button.disabled = false;
    }
  });

  function setFollowing(btn, isFollowing) {
    if (isFollowing) {
      btn.classList.add("is-following");
      btn.querySelector(".brand-follow-button__text").textContent = "Following";
      btn.querySelector(".brand-follow-button__icon").textContent = "x";
    } else {
      btn.classList.remove("is-following");
      btn.querySelector(".brand-follow-button__text").textContent = "Follow For Updates";
      btn.querySelector(".brand-follow-button__icon").textContent = "+";
    }
  }
});